import { render, staticRenderFns } from "./PdfFileCard.vue?vue&type=template&id=2f0be217&scoped=true"
import script from "./PdfFileCard.vue?vue&type=script&lang=js"
export * from "./PdfFileCard.vue?vue&type=script&lang=js"
import style0 from "./PdfFileCard.vue?vue&type=style&index=0&id=2f0be217&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0be217",
  null
  
)

export default component.exports